<template>
  <div class="container">
    <breadcrumbs></breadcrumbs>
    <title-block
      v-if="selectedBuilding"
      :title="selectedBuilding.name | titleFilter"
      :callback="GetOrRefreshData"
    ></title-block>

    <b-select v-model="perPage" class="is-size-7 float-right">
      <option value="5">5 per pagina</option>
      <option value="10">10 per pagina</option>
      <option value="15">15 per pagina</option>
      <option value="20">20 per pagina</option>
      <option value="0">alles</option>
    </b-select>

    <b-table
      :key="tableDataKey"
      v-if="selectedBuilding"
      :checkable="admin"
      hoverable
      :checked-rows.sync="checkedRows"
      :data="selectedBuilding.stories"
      default-sort-direction="asc"
      :paginated="perPage > 0"
      :per-page="perPage"
      @click="row => rowClicked(row)"
    >
      <template>
        <b-table-column cell-class="pointer" field="name" label="Verdieping" sortable v-slot="props">
          {{ props.row.name }}
        </b-table-column>
        <b-table-column cell-class="pointer" field="zones.length" label="# Zones" sortable numeric v-slot="props">{{
          props.row.zones.length
        }}</b-table-column>
        <b-table-column cell-class="pointer" field="openingCount" label="# Openingen" sortable numeric v-slot="props">{{
          props.row.openingCount
        }}</b-table-column>
        <b-table-column
          cell-class="pointer"
          field="lastModification"
          label="Laatste modificatie"
          sortable
          numeric
          v-slot="props"
          >{{ new Date(props.row.lastModification).toLocaleDateString('nl-NL') }}</b-table-column
        >
        <b-table-column cell-class="pointer" field="lastModification" label="Status" sortable v-slot="props">
          <span class="tag fixedwidth" :style="statusColor(props.row.lastModification)">{{
            statusText(props.row.lastModification)
          }}</span>
        </b-table-column>
      </template>
      <template slot="bottom-left" v-if="admin">
        <b>Totaal Geselecteerde Rijen</b>
        : {{ checkedRows.length }}
        <span style="padding-left: 20px">
          <button class="button is-primary" @click="isComponentModalActive = true">Voeg Verdiepingen Toe</button>
        </span>
      </template>
    </b-table>

    <b-loading
      :is-full-page="true"
      :active="isLoading"
      @close="$store.commit('ISLOADING', false)"
      :can-cancel="true"
    ></b-loading>

    <section>
      <b-modal :active.sync="isComponentModalActive" has-modal-card>
        <story-modal
          :buildingId="buildingId"
          :projectId="projectId"
          :story="true"
          @close=";(isComponentModalActive = false), GetOrRefreshData()"
        ></story-modal>
      </b-modal>
    </section>
  </div>
</template>

<script>
import Breadcrumbs from '@/components/General/Breadcrumbs'
import TitleBlock from '@/components/General/TitleBlock'
import { mapGetters } from 'vuex'
import projectService from '@/services/projectService'
import StoryModal from '@/components/Projects/StoryModal'
import rmBtnMixin from '@/mixins/rmBtnMixin.js'

export default {
  components: {
    Breadcrumbs,
    TitleBlock,
    StoryModal
  },
  filters: {
    titleFilter: function (value) {
      if (!value.includes('ebouw') && !value.includes('uilding')) {
        return 'Verdiepingen ' + 'Gebouw ' + value
      }
      return 'Verdiepingen ' + value
    }
  },
  mixins: [rmBtnMixin],
  data() {
    return {
      perPage: 15,
      floorsOverview: [],
      isComponentModalActive: false,
      checkedRows: [],
      admin: false,
      tableDataKey: 0
    }
  },
  computed: {
    ...mapGetters(['selectedBuilding', 'isLoading', 'user', 'adminClaim', 'project']),
    buildingId() {
      return this.$route.params.buildingId
    },
    projectId() {
      return this.$route.params.projectId
    }
  },
  async mounted() {
    this.$store.commit('ISLOADING', true)

    console.log('%cMounted and Loading Data', 'color:yellow;')
    if (this.$store.getters.project.projectId != this.projectId) {
      const res = await projectService.getProject(this.projectId)
      await this.$store.dispatch('setProject', res.data)
    }

    if (!this.$store.getters.selectedBuilding) {
      await projectService.getBuildings(this.projectId).then(async res => {
        console.log(res)
        const index = res.data.buildings.findIndex(o => o.buildingId == this.buildingId)
        const el = res.data.buildings[index]
        await this.$store.commit('SET_SELECTED_BUILDING', el)
        this.GetOrRefreshData()
      })
    }
    // TODO: Create find matching projectId for buildingId (is possible when viewing data)
    // if (this.$store.getters.project.projectId != initProjectId) {
    //   const res = await projectService.getProject(initProjectId)
    //   await this.$store.dispatch('setProject', res.data)
    // }
    const defaultAmountOfRows = 15
    const rows = localStorage.getItem('pagedTableRows')
    this.perPage = rows || defaultAmountOfRows

    if (!this.selectedBuilding.storiesDetailsDataFetched) {
      this.GetOrRefreshData()
    }
  },
  beforeDestroy() {
    localStorage.setItem('pagedTableRows', this.perPage)
  },

  methods: {
    async GetOrRefreshData() {
      this.$store.commit('ISLOADING', true)

      await this.$store.dispatch('getBearerToken')
      this.$store.dispatch('getStoriesAsync', [this.projectId, this.buildingId]).then(() => {
        this.$store.dispatch('updateCrumbs', { name: 'BuildingOverview' })
        this.checkAdmin()
        this.tableDataKey++
      })
    },
    rowClicked(row) {
      this.$store.commit('SET_SELECTED_FLOOR', row)
      this.$router.push('/flooroverview/' + this.projectId + '/' + this.buildingId + '/' + row.storyId)
    },
    statusColor(data) {
      const d = new Date(data)
      const now = new Date()
      const timeDiff = Math.abs(now.getTime() - d.getTime())
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
      if (diffDays < 100) return 'backgroundColor:#b2f068'
      if (diffDays < 200) return 'backgroundColor:#ffdd75'
      if (diffDays < 365) return 'backgroundColor:#ffba6d'
      return 'backgroundColor:#fe816d'
    },
    statusText(data) {
      const d = new Date(data)
      const now = new Date()
      const timeDiff = Math.abs(now.getTime() - d.getTime())
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))
      if (diffDays < 100) return '< 100 dagen'
      if (diffDays < 200) return '< 200 dagen'
      if (diffDays < 365) return '< 1 jaar'
      return '> 1 jaar'
    },
    async deleteRows(rows) {
      let res = ''
      if (rows.length < 1) {
        res = await this.deleteAlert('Verdieping')
      } else {
        res = await this.deleteAlert('Verdiepingen')
      }
      if (res == 'deleted') {
        rows.forEach(async element => {
          await projectService.deleteFloor(this.project.projectId, element.storyId)
          this.GetOrRefreshData()
        })
      }
    },
    async checkAdmin() {
      let bool = false
      bool = await this.$store.dispatch('getProjectAdminClaim', this.projectId)
      this.admin = bool
    }
  }
}
</script>

<style lang="scss" scoped>
td {
  cursor: pointer;
}
.fixedwidth {
  width: 100px;
}
// .clickable {
//   cursor: pointer;
// }
// .clickable:hover {
//   text-shadow: 1px 1px 2px #408eba;
//   color: #2f4858;
//   // TODO: change instead of highlight line appearing at bottom of Tableitem.
//   // border-bottom: 2px;
//   // border-color: gray;
// }
</style>



// WEBPACK FOOTER //
// src/components/Projects/BuildingOverview.vue